export default {

    state: {
      peticao: null,
      msgPeticao: null
    },
  
    mutations: {
        setPeticao(state, payload) {
          state.peticao = payload;
        },
        setMsgPeticao(state, payload) {
          state.msgPeticao = payload;
        }
    },
  
    getters: {
      getPeticao(state) {
          return state.peticao;
      },
      getMsgPeticao(state) {
        return state.msgPeticao;
    }
    },

    actions: {
        setPeticao({commit}, peticao){
          commit('setPeticao', peticao);
        },
        setMsgPeticao({commit}, msgPeticao){
          commit('setMsgPeticao', msgPeticao);
        },
    },
    
  }